<template>
  <FlotoFixedView class="mobile-tab-panel">
    <FlotoPageHeader :title="$tc('knowledge')" class="px-4">
      <template v-slot:after-title>
        <FlotoLink
          v-if="!isPortalLogin"
          id="create-btn"
          as-button
          :to="
            $currentModule.getRoute('create', {
              params: {
                selectedFolder:
                  currentFolder && currentFolder.isTrash
                    ? undefined
                    : currentFolder,
              },
            })
          "
        >
          {{ $t('create') }}
        </FlotoLink>
      </template>
    </FlotoPageHeader>
    <MRow class="my-4 px-4">
      <MCol>
        <FlotoSearchBar
          ref="searchBarRef"
          :module-name="$constants.KNOWLEDGE"
          :allow-save-search="false"
          :persist-criteria="true"
        />
      </MCol>
    </MRow>
    <MRow class="flex-1 min-h-0 master-in-box" :gutter="0">
      <MCol :size="12" :sm="4">
        <FolderSelector
          ref="folderSelectorRef"
          :value="currentFolder"
          :disabled="isPortalLogin"
          :hide-count="Boolean(currentSearchCriteria.length)"
          @change="setSelectedFolder"
        />
      </MCol>
      <MCol
        class="left-shadow-only flex flex-col h-100 px-4"
        :sm="8"
        :size="12"
      >
        <FlotoScrollView>
          <Analytics v-if="showAnalytics" @keyword-selected="addKeyword" />
          <template v-else>
            <FolderDetail
              v-if="(currentFolder || {}).id"
              :folder="currentFolder"
              @edit="editCurrentFolder"
            />
            <KBList
              :folder="currentFolder"
              :hidden-columns="hiddenColumns"
              :search-criteria="currentSearchCriteria"
            />
          </template>
        </FlotoScrollView>
      </MCol>
    </MRow>
  </FlotoFixedView>
</template>

<script>
import { transformSearchCriteriasForServer } from '@data/search'
import { authComputed } from '@state/modules/auth'
import { PageComputed, PageMethods } from '@state/modules/page'
import FolderSelector from '../components/folder/folder-selector'
import Analytics from '../components/analytics'
import FolderDetail from '../components/folder/folder-detail'
import KBList from '../components/kb-list'

export default {
  name: 'KnowledgeList',
  components: { FolderSelector, Analytics, FolderDetail, KBList },
  props: {
    preDefinedKeyword: { type: String, default: undefined },
    hiddenColumns: {
      type: Array,
      default() {
        return []
      },
    },
  },
  computed: {
    ...PageComputed,
    ...authComputed,
    currentFolder() {
      return this.knowledgePageData.selectedFolder
    },
    currentSearchCriteria() {
      const c = this[`${this.$constants.KNOWLEDGE}SearchCriterias`]
      if (c.length) {
        return transformSearchCriteriasForServer(this.$constants.KNOWLEDGE, c)
          .quals
      }
      return []
    },
    showAnalytics() {
      if (
        !this.currentFolder &&
        (this.currentSearchCriteria || []).length === 0
      ) {
        return true
      }
      return false
    },
  },
  mounted() {
    if (this.preDefinedKeyword) {
      this.addKeyword(this.preDefinedKeyword)
    }
  },
  methods: {
    ...PageMethods,
    setSelectedFolder(folder) {
      if (this.currentFolder && this.currentFolder.id === folder.id) {
        this.knowledgeSetPageData({ selectedFolder: null })
      } else {
        this.knowledgeSetPageData({ selectedFolder: folder })
      }
    },
    editCurrentFolder() {
      this.$refs.folderSelectorRef.editFolder(this.currentFolder)
    },
    addKeyword(k) {
      this.$refs.searchBarRef.addKeyword(k)
    },
  },
}
</script>
